import { combineReducers } from 'redux';
import { authReducer } from './Reducer';

const rootReducer = combineReducers({
  auth: authReducer,
  // Add other reducers here
});

export default rootReducer;